import { PageEnum } from './page.js';
/**
 * Blog posts share sites/{siteId}/pages with the built-in pages, keyed by
 * slug. A post must never take an id a page already owns.
 */
const RESERVED_SLUGS = new Set(Object.values(PageEnum));
const MAX_SLUG_LENGTH = 80;
const TRANSLITERATE = {
    æ: 'ae',
    ø: 'o',
    å: 'a',
    ä: 'a',
    ö: 'o',
    ß: 'ss'
};
/**
 * A url-safe slug from a post title: "Sommerkurs på Tiller!" ->
 * "sommerkurs-pa-tiller". Norwegian and Swedish letters are spelled out, other
 * accents are dropped.
 */
const slugify = (title) => title
    .toLowerCase()
    .replace(/[æøåäöß]/g, (ch) => TRANSLITERATE[ch] ?? ch)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, MAX_SLUG_LENGTH)
    .replace(/-+$/, '');
/** Whether a slug can be used as a post id. Uniqueness is checked separately. */
const isValidSlug = (slug) => slug.length > 0 &&
    slug.length <= MAX_SLUG_LENGTH &&
    /^[a-z0-9]+(-[a-z0-9]+)*$/.test(slug) &&
    !RESERVED_SLUGS.has(slug);
export { isValidSlug, RESERVED_SLUGS, slugify };
//# sourceMappingURL=postSlug.js.map